import axiosClient from '../../configs/axios';


class BomService {
    // Get list 
    async getBomList(params) {
        try {
            const response = await axiosClient.get(
                `/bom/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
    async addBom(data) {
        try {
            const response = await axiosClient.post('/bom/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteBom(data) {
        try {
            const response = await axiosClient.put(`/bom/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new BomService(); 